export default {
  mr: { marginRight: '1em' },
  flexEnd: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  styleTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    cursor: 'pointer'
  },
  styleAddFilter: {
    position: 'absolute',
    left: '6%',
    fontSize: '20px',
    color: '#21b4bd'
  },
  styleRemoveFilter: { color: 'red', fontSize: '15px' },
  flexEnd: { display: 'flex', justifyContent: 'flex-end' },
  btn: { color: '#dfdfdf' },
  btnResult: { marginBottom: '15px', color: '#dfdfdf' },
  popupBtnLabel: {
    color: '#748AA1',
    margin: 0,
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px'
  }
};
